import type { Module } from 'vuex'
import type { StoreState } from '../store-state'

/** 근무일정 팝업의 근무코드 필터 — 병원별로 기억한다 */
export type WorkCodeFilter = {
    isShowCustomTimeCode?: boolean
    isShowBasicEmployee?: boolean
}

export type V2WorkCodeFilterState = {
    hospitals: Record<string, WorkCodeFilter | undefined>
}

const state: V2WorkCodeFilterState = {
    hospitals: {},
}

const mutations = {
    'MU_V2WorkCodeFilter_Set': (
        state: V2WorkCodeFilterState,
        param: { hospitalID: string } & WorkCodeFilter,
    ): void => {
        const hospitalID = param.hospitalID
        const isShowCustomTimeCode = param.isShowCustomTimeCode
        const isShowBasicEmployee = param.isShowBasicEmployee

        const filter = state.hospitals[hospitalID] ?? {}
        filter.isShowCustomTimeCode = isShowCustomTimeCode
        filter.isShowBasicEmployee = isShowBasicEmployee

        state.hospitals[hospitalID] = filter
    },
}

const V2WorkCodeFilter: Module<V2WorkCodeFilterState, StoreState> = { state, mutations }

export default V2WorkCodeFilter
